export function isTabVisible(tab, visKey) {
    if (typeof tab.visible === 'boolean') {
        return tab.visible;
    }
    if (typeof tab.visible === 'object' && tab.visible) {
        return !!tab.visible[visKey];
    }
    return true;
}
